export default __webpack_public_path__ + "static/downshift_ss_1-e5770377e88081012640861c55f6061d.jpg";